import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/lib/services/api.service';
import { heightAnimation } from 'src/lib/animations';
import { AppService } from 'src/lib/services/app.service';
import { MicrosoftService } from '@lib/services/microsoft.service';
import { AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { first, Subscription } from 'rxjs';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

enum Views {
	Beta = 'beta',
	Azure = 'azure',
	Support = 'support'
}

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [heightAnimation]
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {

    private subscriptions = new Subscription();

	Views = Views;

	@ViewChild(Views.Support+'Template') supportTemplateRef: TemplateRef<any>
	@ViewChild(Views.Beta+'Template') betaTemplateRef: TemplateRef<any>
	@ViewChild(Views.Azure+'Template') azureTemplateRef: TemplateRef<any>

	version: string = this.appService.environment.version;

	isBeta: boolean = this.appService.isBeta;
	isDevelopment: boolean = this.appService.isDevelopment;
	
	isAuthenticated: boolean = this.apiService.isAuthenticated;

	connectState: {isWaiting?: boolean, isRedirecting?: boolean, views?: Views[], error?: string, params?: any} = {
        views: [Views.Azure, ...((this.isDevelopment || this.isBeta) ? [Views.Beta] : [])]
    };

	constructor(public apiService: ApiService,
				private appService: AppService,
				private changeDetector: ChangeDetectorRef,
				private router: Router,
                private activatedRoute: ActivatedRoute,
                private microsoftService: MicrosoftService,
                private msalBroadcastService: MsalBroadcastService,
                private msalService: MsalService
    ){}

    ngOnInit(): void {

        this.subscriptions.add(
            this.msalBroadcastService.inProgress$.subscribe((status: InteractionStatus) => {

                if(status === InteractionStatus.HandleRedirect) {
                    this.connectState.isWaiting = true;
                    this.connectState.isRedirecting = true;

                    this.msalService.handleRedirectObservable().pipe(first()).subscribe({
                        next: (result: AuthenticationResult) => {                
            
                            if(result) {
                
                                const {account, idToken} = result;
                
                                this.apiService.connect({...account, idToken}).subscribe({
                                    next: authentication => {
                                        if(authentication.authenticated) {
                    
                                            const storedLocation = localStorage.getItem("persistent.redirect.location");
                
                                            if(storedLocation)
                                                this.router.navigate([storedLocation], {replaceUrl: true});
                                            else
                                                this.router.navigate([this.activatedRoute.snapshot.queryParams.return ?? "/"], {replaceUrl: true}); 
                                        }
                                    },
                                    error: (errorResponse: HttpErrorResponse) => {
                                        this.connectState.isWaiting = false;
                                        this.connectState.error = errorResponse.message
                                    }
                                });
                            }
                        },
                        error: error => {
                            this.connectState.isWaiting = false;
                            this.connectState.error = error.message
                        }
                    });
                }
            })
        );
    }

    connect() {
        this.connectState.isWaiting = true;
        this.microsoftService.authenticate().subscribe();
    }

	ngAfterViewInit () {
		this.changeDetector.detectChanges();
	}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
